export default __webpack_public_path__ + "static/media/iOSLogo.5e0e2701.svg";